export enum CaseFileType {
  unknown = 'Unknown',
  file = 'File',
  location = 'Location',
}
